<script>
import { VBreadcrumbs } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib/components'
import EBreadcrumbsItem from './EBreadcrumbsItem.vue'

export default {
  name: 'EBreadcrumbs',
  extends: VBreadcrumbs,
  props: {
    divider: {
      type: String,
      default: 'icon-chevron-right',
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'e-breadcrumbs': true,
        'e-breadcrumbs--large': this.large,
        'e-breadcrumbs--small': this.small,
        ...this.themeClasses,
      }
    },
  },
  methods: {
    genDivider() {
      return this.$createElement(
        VIcon,
        {
          class: 'e-breadcrumbs__divider',
          props: {
            size: 24,
          },
        },
        this.$slots.divider ? this.$slots.divider : this.divider
      )
    },

    genItems() {
      const items = []
      const hasSlot = !!this.$scopedSlots.item
      const keys = []

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        keys.push(item.text)
        if (hasSlot)
          items.push(
            this.$scopedSlots.item({
              item,
            })
          )
        else
          items.push(
            this.$createElement(
              EBreadcrumbsItem,
              {
                key: keys.join('.'),
                props: {
                  ...item,
                  small: this.small,
                  large: this.large,
                },
              },
              [item.text]
            )
          )
        if (i < this.items.length - 1) items.push(this.genDivider())
      }

      return items
    },
  },

  render(h) {
    const children = this.$slots.default || this.genItems()
    return h(
      'span',
      {
        staticClass: 'v-breadcrumbs',
        class: this.classes,
      },
      children
    )
  },
}
</script>
